// this mode extends the build-in polygon tool, displaying the current area
// of the polygon in hectares as the user draws using a point feature and a symbol layer
import MapboxDraw, { DrawCustomMode, DrawCustomModeThis } from "@mapbox/mapbox-gl-draw";

import { createMeasurementVertex, displayStartEndVertexes } from "./utils";

const ExtendedPolygonMode = {
    ...MapboxDraw.modes.draw_polygon,

    toDisplayFeatures: function (
        state: {
            polygon: GeoJSON.Feature<GeoJSON.Polygon>;
            direction: string;
        },
        geojson: GeoJSON.Feature<GeoJSON.Polygon>,
        display: (geojson: GeoJSON.GeoJSON) => void,
    ) {
        const originalToDisplayFeatures = MapboxDraw.modes.draw_polygon.toDisplayFeatures;
        originalToDisplayFeatures.call(this as DrawCustomModeThis & DrawCustomMode<unknown, unknown>, state, geojson, display);
        displayStartEndVertexes(geojson, display);

        if (!state.polygon.id || geojson.properties?.id !== state.polygon.id || geojson.geometry.coordinates.length < 1) {
            return;
        }

        const mainCoordinates = geojson.geometry.coordinates[geojson.geometry.coordinates.length - 1];
        if (mainCoordinates.length < 3) return;
        display(createMeasurementVertex(geojson, state.polygon.id, mainCoordinates[mainCoordinates.length - 2]));
    },
};

export default ExtendedPolygonMode;
